import Request from './request'

async function fetch (data) {
  var headers = []
  if (localStorage.getItem('midAccessToken'))
    headers['access-token'] = localStorage.getItem('midAccessToken')
  return Request(
    'get',
    localStorage.getItem('pushMidURL') + '/api/order-analyses/index',
    data,
    false,
    headers
  )
}

async function fetchOne (data) {
  var headers = []
  if (localStorage.getItem('midAccessToken'))
    headers['access-token'] = localStorage.getItem('midAccessToken')
  return Request(
    'get',
    localStorage.getItem('pushMidURL') + '/api/order-analyses/view',
    data,
    false,
    headers
  )
}

export default {
  fetch,
  fetchOne,
}
